<template>
  <div class="not-found">
    <span>404</span>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.not-found {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100vh;
  span {
    font-size: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
